"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainExplorer = void 0;
const definitions_1 = require("@ppay/definitions");
exports.BlockchainExplorer = {
    [definitions_1.Blockchain.BINANCE_SMART_CHAIN]: {
        network: 'BEP20',
        ticker: definitions_1.Ticker.BNB,
        link: 'https://bscscan.com/tx/',
        address: 'https://bscscan.com/address/',
        title: 'bscscan.com'
    },
    [definitions_1.Blockchain.BITCOIN]: {
        network: 'Bitcoin',
        ticker: definitions_1.Ticker.BTC,
        link: 'https://www.blockchain.com/btc/tx/',
        address: 'https://www.blockchain.com/btc/address/',
        title: 'blockchain.com'
    },
    [definitions_1.Blockchain.ETHEREUM]: {
        network: 'ERC20',
        ticker: definitions_1.Ticker.ETH,
        link: 'https://etherscan.io/tx/',
        address: 'https://etherscan.io/address/',
        title: 'etherscan.io'
    },
    [definitions_1.Blockchain.TRON]: {
        network: 'TRC20',
        ticker: definitions_1.Ticker.TRX,
        link: 'https://tronscan.org/#/transaction/',
        address: 'https://tronscan.io/#/address/',
        title: 'tronscan.org'
    },
    [definitions_1.Blockchain.POLYGON]: {
        network: 'ERC-20',
        ticker: definitions_1.Ticker.MATIC,
        link: 'https://polygonscan.com/tx',
        address: 'https://polygonscan.com/address/',
        title: 'polygonscan.com'
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwbG9yZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZXhwbG9yZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbURBQXNEO0FBRXpDLFFBQUEsa0JBQWtCLEdBQUc7SUFDaEMsQ0FBQyx3QkFBVSxDQUFDLG1CQUFtQixDQUFDLEVBQUU7UUFDaEMsT0FBTyxFQUFFLE9BQU87UUFDaEIsTUFBTSxFQUFFLG9CQUFNLENBQUMsR0FBRztRQUNsQixJQUFJLEVBQUUseUJBQXlCO1FBQy9CLE9BQU8sRUFBRSw4QkFBOEI7UUFDdkMsS0FBSyxFQUFFLGFBQWE7S0FDckI7SUFDRCxDQUFDLHdCQUFVLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDcEIsT0FBTyxFQUFFLFNBQVM7UUFDbEIsTUFBTSxFQUFFLG9CQUFNLENBQUMsR0FBRztRQUNsQixJQUFJLEVBQUUsb0NBQW9DO1FBQzFDLE9BQU8sRUFBRSx5Q0FBeUM7UUFDbEQsS0FBSyxFQUFFLGdCQUFnQjtLQUN4QjtJQUNELENBQUMsd0JBQVUsQ0FBQyxRQUFRLENBQUMsRUFBRTtRQUNyQixPQUFPLEVBQUUsT0FBTztRQUNoQixNQUFNLEVBQUUsb0JBQU0sQ0FBQyxHQUFHO1FBQ2xCLElBQUksRUFBRSwwQkFBMEI7UUFDaEMsT0FBTyxFQUFFLCtCQUErQjtRQUN4QyxLQUFLLEVBQUUsY0FBYztLQUN0QjtJQUNELENBQUMsd0JBQVUsQ0FBQyxJQUFJLENBQUMsRUFBRTtRQUNqQixPQUFPLEVBQUUsT0FBTztRQUNoQixNQUFNLEVBQUUsb0JBQU0sQ0FBQyxHQUFHO1FBQ2xCLElBQUksRUFBRSxxQ0FBcUM7UUFDM0MsT0FBTyxFQUFFLGdDQUFnQztRQUN6QyxLQUFLLEVBQUUsY0FBYztLQUN0QjtJQUNELENBQUMsd0JBQVUsQ0FBQyxPQUFPLENBQUMsRUFBRTtRQUNwQixPQUFPLEVBQUUsUUFBUTtRQUNqQixNQUFNLEVBQUUsb0JBQU0sQ0FBQyxLQUFLO1FBQ3BCLElBQUksRUFBRSw0QkFBNEI7UUFDbEMsT0FBTyxFQUFFLGtDQUFrQztRQUMzQyxLQUFLLEVBQUUsaUJBQWlCO0tBQ3pCO0NBQ0YsQ0FBQSJ9